import { useQuery } from "react-query";
import { TournamentAPI } from "api/tournament";
import { CURRENT_TOURNAMENT } from "helpers/constants";

export default function useCurrentTournament() {
  return useQuery(CURRENT_TOURNAMENT, TournamentAPI.getCurrentTournament);
}
